module.exports = require("core-js/library/fn/date/now");